// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61045103","337":"8bc5b830","453":"49f46710","732":"ac28ea01"}[chunkId] + ".chunk.js";
};